import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import {
  FaChair,
  FaIdCard,
  FaCheckCircle,
  FaRegCircle,
  FaPlus,
} from "react-icons/fa";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { fetchVehiclesData } from "../../../../store/vehicles/actions";
import VehicleCreate from "./VehicleAdd";
import "./Vehicle.css";
import VehicleDocumentUpload from "./VehicleDocumentUpload";

const VehicleAdd = ({ onBack }) => {
  return <VehicleCreate onBacked={onBack}></VehicleCreate>;
};

const DriverVehicles = () => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.Vehicles);

  const [vehicles, setVehicles] = useState([]);
  const [loadingId, setLoadingId] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [vehicleId, setVehicleId] = useState('');

  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  useEffect(() => {
    dispatch(fetchVehiclesData());
  }, [dispatch]);

  useEffect(() => {
    if (!loading) {
      setVehicles(data?.data || []);
    }
  }, [data, loading]);

  const handleCardClick = async (vehicle) => {
    const newStatus = vehicle.is_enable ? 0 : 1;
    try {
      const url = process.env.REACT_APP_WEB_APP_URL + `/api/vehicle-status`;
      const token = localStorage.getItem("authToken");

      const response = await axios.post(
        url,
        { vehicle_id: vehicle.id, status: newStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        toast.success("Vehicle Status updated successfully", { autoClose: 3000 });
        dispatch(fetchVehiclesData());
      } else {
        toast.error(data?.message || `Error: ${response.statusText}`, {
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error updating vehicle status:", error);
    }
  };

  const handleCreateVehicle = () => {
    setShowAddForm(true);
  };

  const handleBackFromCreate = () => {
    setShowAddForm(false);
    dispatch(fetchVehiclesData());
  };

  const handleBackFromDocumentModal = () => {
    setShowUploadModal(false);
    dispatch(fetchVehiclesData());
  };

  const handleViewVehicle = (vehicle) => {
    setSelectedVehicle(vehicle);
    setShowModal(true);
  };

  const renderSkeletonCard = (i) => (
    <div key={i} className="col-12 col-sm-6 col-md-4">
      <Skeleton height={500} className="shadow-lg rounded-4 " />
    </div>
  );

  if (showAddForm) {
    return <VehicleAdd onBack={handleBackFromCreate} />;
  }

  document.title = "Vehicles | Sawari Online";

  return (
    <div className="container">
      <div className="row g-4">
        {loading
          ? Array.from({ length: 2 }).map((_, i) => renderSkeletonCard(i))
          : Array.isArray(vehicles) && vehicles.length > 0
            ? vehicles.map((vehicle) => (
              <div key={vehicle.id} className="col-12 col-sm-6 col-md-4">
                <div
                  className="card vehicle-card h-100 shadow-lg rounded-4 overflow-hidden"
                  style={{
                    transition: "transform 0.3s",
                    cursor: vehicle.vehicle_status != "no_document" ? "pointer" : "inherit",
                    border: vehicle.is_enable
                      ? "3px solid #6B0729"
                      : "2px solid #ddd",
                    position: "relative",
                  }}
                  onClick={() => { vehicle.vehicle_status != "no_document" && vehicle.in_service == 1 ? handleCardClick(vehicle) : null }}
                >
                  <div className="position-relative">
                    {vehicle.vehicle_status != "no_document" && vehicle.vehicle_status != "rejected" && vehicle.in_service == 1 ? (
                      <>
                        {loadingId === vehicle.id ? (
                          <Skeleton
                            height={25}
                            width={25}
                            className="position-absolute top-0 start-0 m-2 rounded-circle"
                          />
                        ) : vehicle.is_enable ? (
                          <FaCheckCircle
                            className="position-absolute top-0 start-0 m-2"
                            size={25}
                            color="#6B0729"
                          />
                        ) : (
                          <FaRegCircle
                            className="position-absolute top-0 start-0 m-2"
                            size={25}
                            color="#6B0729"
                          />
                        )}
                      </>
                    ) : null}

                    <img
                      src={
                        vehicle.vehicle_media[0]?.url ||
                        "/placeholder-vehicle.png"
                      }
                      alt={vehicle.make_name}
                      className="img-fluid w-100"
                      style={{ height: "220px", objectFit: "cover" }}
                    />
                    <div className="position-absolute top-0 end-0 m-2">
                      <span className="badge bg-primary-dark px-3 py-2 rounded-pill">
                        {vehicle.type_name}
                      </span>
                    </div>
                  </div>

                  <div className="card-body text-center">
                    <h5 className="card-title fw-bold mb-2">
                      {vehicle.make_name} - {vehicle.model_name}
                    </h5>
                    <p className="text-secondary mb-1">
                      {vehicle.year} • {vehicle.body_type}
                    </p>
                    <p className="text-muted d-flex justify-content-center align-items-center gap-2 mb-1">
                      <FaIdCard /> {vehicle.license_plate}
                    </p>
                    <p className="text-muted d-flex justify-content-center align-items-center gap-2 mb-2">
                      <FaChair /> {vehicle.seats} Seats
                    </p>

                    {vehicle.vehicle_status === "no_document" ? (
                      <span className="badge bg-danger text-white px-3 py-2 rounded-pill mb-2">
                        🚨 Missing Documents
                      </span>
                    ) : null}

                    {vehicle.vehicle_status != "no_document" ? (
                      <>
                        {vehicle.in_service === 0 ? (
                          <span className="badge bg-warning text-dark px-3 py-2 rounded-pill mb-3">
                            ⏳ Waiting for Admin Approval
                          </span>
                        ) : (
                          <span className="badge bg-success text-white px-3 py-2 rounded-pill mb-3">
                            ✅ Approved by Admin
                          </span>
                        )}
                      </>
                    ) : null}

                    <div className="d-flex justify-content-center">
                      <span className="badge bg-primary text-white fs-6 px-3 py-2 rounded-pill">
                        PKR {vehicle.seat_rate}
                      </span>
                    </div>
                  </div>

                  {/* Drawer on hover */}
                  <div className="vehicle-drawer">
                    <button
                      className="btn btn-outline-primary w-100"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewVehicle(vehicle);
                      }}
                    >
                      View Vehicle
                    </button>
                  </div>
                </div>
              </div>
            ))
            : null }

        <div className="col-12 col-sm-6 col-md-4">
          <div
            className="card h-100 shadow-lg rounded-4 d-flex justify-content-center align-items-center"
            style={{
              cursor: "pointer",
              border: "2px dashed #6B0729",
              minHeight: "350px",
            }}
            onClick={handleCreateVehicle}
          >
            <FaPlus size={50} color="#6B0729" />
          </div>
        </div>
      </div>

      {showModal && selectedVehicle && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content rounded-4 shadow-lg">
              <div className="modal-header">
                <h5 className="modal-title">
                  {selectedVehicle.make_name} {selectedVehicle.model_name} (
                  {selectedVehicle.year})
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                {selectedVehicle.vehicle_media.length > 0 && (
                  <div className="d-flex flex-wrap gap-3 justify-content-center mb-4">
                    {selectedVehicle.vehicle_media.map((media, index) => (
                      <a
                        key={index}
                        href={media.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={media.url}
                          alt={`Vehicle ${index}`}
                          className="vehicle-modal-img"
                        />
                      </a>
                    ))}
                  </div>
                )}

                <p>
                  <strong>Body Type:</strong> {selectedVehicle.body_type}
                </p>
                <p>
                  <strong>License Plate:</strong> {selectedVehicle.license_plate}
                </p>
                <p>
                  <strong>Seats:</strong> {selectedVehicle.seats}
                </p>
                <p>
                  <strong>Seat Rate:</strong> PKR {selectedVehicle.seat_rate}
                </p>

                <div className="d-flex align-items-center mt-3">
                  <img
                    src={selectedVehicle.driver.image}
                    alt={selectedVehicle.driver.name}
                    className="rounded-circle me-3"
                    style={{ width: "50px", height: "50px" }}
                  />
                  <div>
                    <h6 className="mb-0">{selectedVehicle.driver.name}</h6>
                    <small className="text-muted">{selectedVehicle.driver.email}</small>
                  </div>
                </div>

                <div className="mb-4">
                  <h6 className="my-3">Vehicle Documents</h6>
                  <div className="row g-3">
                    {selectedVehicle.vehicle_documents && selectedVehicle.vehicle_documents.length > 0 ? (
                      <>
                        {selectedVehicle.vehicle_documents.map((doc, index) => {

                          let badgeClass = "bg-secondary";
                          if (doc.status === "approved") badgeClass = "bg-success";
                          if (doc.status === "pending") badgeClass = "bg-warning text-dark";
                          if (doc.status === "rejected") badgeClass = "bg-danger";

                          return (
                            <div key={index} className="col-6 col-md-4">
                              <div className="card shadow-sm border-0 h-100 position-relative">
                                <span
                                  className={`badge ${badgeClass} position-absolute top-0 end-0 m-2 px-2 py-1`}
                                  style={{ fontSize: "0.75rem", borderRadius: "0.5rem" }}
                                >
                                  {doc.status ? doc.status.charAt(0).toUpperCase() + doc.status.slice(1) : "Pending"}
                                </span>

                                <div className="card-body text-center p-3">
                                  <a
                                    href={doc.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-decoration-none"
                                  >
                                    <img
                                      src={doc.url}
                                      alt={doc.document_type_name || `Document ${index}`}
                                      className="img-fluid rounded mb-2 border"
                                      style={{
                                        maxHeight: "120px",
                                        objectFit: "cover",
                                        width: "100%",
                                      }}
                                    />
                                    <p className="small text-muted mb-1 fw-semibold">
                                      {doc.document_type_name || `Document ${index + 1}`}
                                    </p>
                                    {doc.view && (
                                      <p className="small text-primary mb-0">
                                        View: {doc.view.charAt(0).toUpperCase() + doc.view.slice(1)}
                                      </p>
                                    )}
                                    {doc.remarks && (
                                      <p className="small text-muted fw-semibold">
                                        Remarks: {doc.remarks}
                                      </p>
                                    )}
                                  </a>

                                  {doc.status === "rejected" && (
                                    <button
                                      className="btn btn-sm btn-outline-danger mt-2"
                                      onClick={() => {
                                        setShowModal(false);
                                        setShowUploadModal(true);
                                        setVehicleId(selectedVehicle.id);
                                      }}
                                    >
                                      Re-Upload
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      <div className="col-12 text-center">
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            setShowModal(false);
                            setShowUploadModal(true);
                            setVehicleId(selectedVehicle.id);
                          }}
                        >
                          Upload Documents
                        </button>
                      </div>
                    )}
                  </div>
                </div>

              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showUploadModal && (
        <VehicleDocumentUpload vehicleId={vehicleId} onClose={() => handleBackFromDocumentModal()}></VehicleDocumentUpload>
      )}

    </div>
  );
};

export default DriverVehicles;